import EcosystemWheel from './ecosystemWheel.js';

new EcosystemWheel('[data-ecosystem-wheel]');
